import * as React from 'react';
import { Link } from 'react-router-dom';
import * as moment from 'moment';

function createMarkup(html) {
    return {
        __html: html
    };
}

export const CategoryItem = ({ category, selectCategory }) => {
    return (<Link className='item' to={'categories/' + category.alias} onClick={(e) => selectCategory(category.alias)}>
        {category.image && <div className='image'>
            <img src={category.image} />
        </div>}
        <div className='content'>
            <div className='header'>{category.title}</div>
            <div className='meta'>{moment(category.date).format('Do MMMM YYYY')}</div>
            <div className='description' dangerouslySetInnerHTML={createMarkup(category.description)}></div>
        </div>
    </Link>);
}



// WEBPACK FOOTER //
// ./src/components/categories/category-item.presentation.tsx